export default {
    tab: {
        trendSelection: 'Trend selection',
        internalEvaluationOptions: 'internal evaluation',
        publicEvaluationOptions: 'public evaluation'
    }
}
